export enum ProductType {
  TrackersOnly,
  Tracs,
  Soma,
  TracsLite,
  MonitorOnly,
}

export interface IPurchasedProductsBySite {
  [siteId: string]: ProductType[];
}
